import { render, staticRenderFns } from "./TeacherWorkRegimeRule.vue?vue&type=template&id=3589f7c2"
import script from "./TeacherWorkRegimeRule.vue?vue&type=script&lang=js"
export * from "./TeacherWorkRegimeRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3589f7c2')) {
      api.createRecord('3589f7c2', component.options)
    } else {
      api.reload('3589f7c2', component.options)
    }
    module.hot.accept("./TeacherWorkRegimeRule.vue?vue&type=template&id=3589f7c2", function () {
      api.rerender('3589f7c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/TeacherWorkRegimeRule.vue"
export default component.exports